import { CheckCircleFilled, CheckCircleOutlined, CheckSquareOutlined, ClockCircleFilled, ClockCircleOutlined, CloseCircleFilled, CloseCircleOutlined, PictureOutlined, PlusCircleOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useContext, useMemo, useState } from 'react';
import '../pages.scss'
import { FilterDropdownProps } from 'antd/lib/table/interface';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../../store/AuthContext/AuthContext';
import { DrawerContext } from '../../../store/DrawerContext/DrawerContext';
import { useFetch } from '../../../hooks/useFetch/useFetch';
import ColorScore from '../../../common/utils/ColorScore';
import { Location, LocationCardCompacted } from '../../components/model/business/FieldsGroup';
import { Synchronized } from '../../components/design/Synchronized/Synchronized';
import { BlockContentKpis } from '../menuReports/blocks/BlockContentKpis';
import { SCHEDULEDJOB } from '../../../common/constants/services';
import GooglePublishPanel from './LocalPosts/GooglePublishPanel';
import TableLZM from '../../components/design/table/TableLZM';
import ImagePublishPanel from './LocalPosts/ImagePublishPanel';
import { useIsAuthorized } from '../common/roles/Roles';
import SelectPeriod from '../../components/model/selectMonths/SelectPeriod';
import SelectVirtualGroup, { NO_REGION_FILTER } from '../../components/model/selectMonths/SelectVirtualGroup';
import { GlobalVariableContext } from '../../../store/GlobalVariableContext/GlobalVariableContext';
import { ButtonLZ } from '../../components/design/Buttons/ButtonLZ';
import { PageTitle } from '../common/PageTitle';
import { PageFilters, PageFilterField } from '../common/PageFilters';

export const GooglePublishContent = () => {

	const { t } = useTranslation();
	
	const { projectGroup } = useAuth();
	const [publishMassivePanelVisible, setPublishMassivePanelVisible] = useState(false);	
	const [publishOnePanelVisible, setPublishOnePanelVisible] = useState(null);	
	const [imagePublishMassivePanelVisible, setImagePublishMassivePanelVisible] = useState(false);
	const [imagePublishOnePanelVisible, setImagePublishOnePanelVisible] = useState(null);	
	const [updateData, setUpdateData] = useState(false);
	const { updateGlobalData } = useContext(GlobalVariableContext)	
	const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
	const isAuthorized = useIsAuthorized();
	const { setLocationDrawer } = useContext(DrawerContext)
	const { setLogsDrawer } = useContext(DrawerContext);
	const { setPostsDrawer } = useContext(DrawerContext);
	const { setScheduledPostsDrawer } = useContext(DrawerContext);
	const [filterReference, setFilterReference] = useState('LAST_12MONTHS');
	const [filterLabel, setFilterLabel] = useState(null);

	const history = useHistory();	
	const location = useLocation();

	const onRangeChange = (range: any) => {      
        setFilterReference(range);
    };

	const publish = async (selectedLocation: any) => {
				
		setSelectedRowKeys([selectedLocation.composeId]);		
		setPublishOnePanelVisible(selectedLocation);		
	};

	const uploadPhoto = async (selectedLocation: any) => {
				
		setSelectedRowKeys([selectedLocation.composeId]);				
		setImagePublishOnePanelVisible(selectedLocation);		
	};

	const apiFilterLabel = filterLabel === NO_REGION_FILTER ? '' : (filterLabel || '');

	const { data, isLoading }: any = useFetch(
		`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/locations/posts?periodOpt=${filterReference}&filterLabel=${encodeURIComponent(apiFilterLabel)}`,
		{},
		[updateData, updateGlobalData, filterLabel],
	);

	const contentData = useMemo(() => {
		const content = data?.content ?? [];
		if (filterLabel !== NO_REGION_FILTER) return content;
		return content.filter((row: any) => !row.label);
	}, [data, filterLabel]);

	const columns: any = [
		{
			title: 'Sin publicar',
			align: 'center',
			width: '140px',
			key: 'daysWithoutPost',
			dataIndex: 'daysWithoutPost',
			render: (text: string, record: any) => (
				record.numberOfPost > 0 ? 
						<ColorScore value={record.daysWithoutPost} />					
						:
						<i style={{color:'MediumVioletRed'}}>Sin posts</i>
			),
			sorter: (a: any, b: any) => b.daysWithoutPost - a.daysWithoutPost
		},
		{
			title: 'Establecimiento',
			key: 'location',						
			sorter: (a: any, b: any) => a.locality?.localeCompare(b.locality),
			filterDropdown: ({
			  setSelectedKeys,
			  selectedKeys,
			  confirm,			  
			}: FilterDropdownProps) => {
			  return (
				<Input
				  autoFocus
				  //placeholder="Filtro"
				  value={selectedKeys[0]}
				  onChange={(e: any) => {
					setSelectedKeys(e.target.value ? [e.target.value] : []);
					confirm({ closeDropdown: false });
				  }}
				  onPressEnter={() => {
					confirm();
				  }}
				  onBlur={() => {
					confirm();
				  }}
				></Input>
			  );
			},
			filterIcon: () => {
			  return <SearchOutlined />;
			},
			onFilter: (value: any, record: any) => {
				return record.title?.toLowerCase().includes(value?.toLowerCase()) 
				|| record.administrativeArea?.toLowerCase().includes(value?.toLowerCase())
				|| record.locality?.toLowerCase().includes(value?.toLowerCase());
			},
			render: (text: string, record: any) => (
				<LocationCardCompacted location={record} onChange={() => {setLocationDrawer(record.composeId);}} label={true}/>									
			),
		},	
		{
			title: 'Publicado',
			key: 'numberOfPost',
			align: 'center',
			dataIndex: 'numberOfPost',
			width: '200px',
			render: (text: string, record: any) => (
				record.numberOfPost ? 					
					<Button type='link' onClick={()=>{setPostsDrawer(record.composeId)}} size='small' >    
						<span><CheckCircleFilled style={{color:'green'}}/> {record.numberOfPost} posts</span>
					</Button>									
					:
					<i style={{color:'lightgrey'}}>Sin posts</i>
			),
			sorter: (a: any, b: any) => b.numberOfPost - a.numberOfPost
		},
		{
			title: 'Programaciones',
			key: 'numberOfScheduled',
			dataIndex: 'numberOfScheduled',
			width: '200px',
			render: (text: string, record: any) => (
				record.numberOfScheduled ? 								
					<>
						<Button type='link' onClick={()=>{setScheduledPostsDrawer({locationId: record.composeId, status: 'SCHEDULED', selectedType: filterReference})}} size='small' >    						
							<span><ClockCircleFilled/> {record.numberOfScheduled} pendientes</span>					
						</Button>									
					</>
					:
					<i style={{color:'lightgrey'}}>Sin Programaciones</i>
			),
			sorter: (a: any, b: any) => b.numberOfScheduled - a.numberOfScheduled
		},		
		{
			title: 'Errores',
			key: 'numberOfErrors',
			dataIndex: 'numberOfErrors',
			width: '200px',
			render: (text: string, record: any) => (
				record.numberOfErrors ? 								
					<>
						<Button type='link' onClick={()=>{setScheduledPostsDrawer({locationId: record.composeId, status: 'ERROR', selectedType: filterReference})}} size='small' >    											
							<span><CloseCircleFilled style={{color:'MediumVioletRed'}}/> {record.numberOfErrors} errores</span>					
						</Button>			
					</>
					:
					<i style={{color:'lightgrey'}}>Sin errores</i>
			),
			sorter: (a: any, b: any) => b.numberOfErrors - a.numberOfErrors
		},		
		{
			title: '',
			key: 'locationId',		
			width: '230px',
			render: (text: string, record: any) => (
				<div style={{display:'flex', justifyContent:'space-between'}}>	
					<ButtonLZ onClick={()=>{publish(record)}} size='small' disabled={!isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_CONTENT'])} >    
						<PlusCircleOutlined/> Publicar	
					</ButtonLZ>	
					<ButtonLZ onClick={()=>{uploadPhoto(record)}} size='small' disabled={!isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_CONTENT'])} >    
						<UploadOutlined/> Foto
					</ButtonLZ>										
				</div>
			)
		}
	]

	const onSelectChange = (selectedRowKeys: any) => {
		setSelectedRowKeys(selectedRowKeys);
		setIndeterminate(true);

	}

	const [indeterminate, setIndeterminate] = useState(false);

	const onSelectAllCustom = (selected: boolean) => {
		setSelectedRowKeys(selected ? contentData.map((row: any) => row.composeId) : []);
		setIndeterminate(false);
	}

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
		columnTitle: <Checkbox indeterminate={indeterminate} onChange={(e) => onSelectAllCustom(e.target.checked)}></Checkbox>,
	}

	const hasSelected = selectedRowKeys.length > 0
	const canMassEdit = isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_CONTENT']);
	const massiveVisible = !hasSelected || !canMassEdit;

	/* Contenidos - Gesti�n masiva */

	return (
		<>
			<Card className='main-card-content'>

				<div style= {{width:'100%', display:'flex', justifyContent:'space-between'}}>
					<PageTitle
						title='Gestión de Publicaciones'
						pageInfo='Publicar posts y fotos de forma regular forma parte del trabajo recurrente de una buena estrategia de seo local junto con fomentar y contestar las reseñas. Esta funcionalidad permite publicar con la ayuda de la IA para los textos e incluso programar tus publicaciones. Si además gestionas un negocio con múltiples locales podrás hacerlo de forma masiva.'
						extra={
							<Button type='link' onClick={() => setLogsDrawer(true)}>
								Ver Registro
							</Button>
						}
					/>
				</div>
				
				<div style={{ minHeight: '35px', marginTop: '20px' }}>
					<Synchronized service={[SCHEDULEDJOB.GBP_POSTS]} />
					
					<div style= {{width:'100%', display:'flex', justifyContent:'space-between'}}>

						
							{/* Acciones Masivas visual container - compact */}
							<div 
								style={{
									background: massiveVisible ? '#f8fafc' : '#eef5ff',
									border: massiveVisible ? '1px dashed #b8c0cc' : '1px solid #4A90E2',
									borderRadius: '8px',
									padding: '8px 14px',
									display: 'flex',
									flexDirection: 'column',
									gap: 2,
									minWidth: 340,
									marginRight: 16,
									opacity: massiveVisible ? 0.85 : 1,
									transition: 'opacity 0.2s, border-color 0.2s, background 0.2s',
								}}
							>
								<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
									<span style={{ 
										display: 'flex',
										alignItems: 'center',
										gap: 6,
										color: '#000',
										fontSize: 13,
										fontWeight: 700,
										whiteSpace: 'nowrap',
										letterSpacing: '0.02em',
									}}>
										<PlusCircleOutlined style={{ fontSize: 15, color: '#000' }} /> Acciones Masivas
									</span>
									<div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
										<Button
											type="link"
											onClick={() => setPublishMassivePanelVisible(true)}
											disabled={massiveVisible}
											style={{ display: 'flex', alignItems: 'center', minWidth: 60, justifyContent: 'left', padding: 0, fontSize: 13, height: 24 }}
										>
											{t('dictionary.publish')}
										</Button>
										<Button
											type="link"
											onClick={() => setImagePublishMassivePanelVisible(true)}
											disabled={massiveVisible}
											style={{ display: 'flex', alignItems: 'center', minWidth: 60, justifyContent: 'left', padding: 0, fontSize: 13, height: 24 }}
										>
											{t('dictionary.photo')}
										</Button>
									</div>
								</div>
								{massiveVisible ? (
									<span style={{ fontSize: 12, color: '#4a6278', display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
										<CheckSquareOutlined />
										Selecciona locales en la tabla
									</span>
								) : (
									<span style={{
										alignSelf: 'flex-start',
										fontSize: 12,
										fontWeight: 600,
										color: '#334155',
										background: '#fff',
										border: '1px solid #93c5fd',
										borderRadius: 999,
										padding: '1px 8px',
										whiteSpace: 'nowrap',
									}}>
										{`${selectedRowKeys.length} de ${contentData.length} seleccionados`}
									</span>
								)}
							</div>
							<div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
								<PageFilters>
									<PageFilterField label='Región' active={filterLabel != null}>
										<SelectVirtualGroup onChange={(obj: any) => { setFilterLabel(obj); }} />
									</PageFilterField>
									<PageFilterField label='Periodo'>
										<SelectPeriod setSelectedType={onRangeChange} defaultValue='LAST_12MONTHS' />
									</PageFilterField>
								</PageFilters>
							</div>
	
					</div>											
				</div>				

				<TableLZM
					rowSelection={rowSelection}
					rowKey='composeId'
					scroll={{ x: true, y: 800 }}
					columns={columns}
					pagination={{ defaultPageSize: 20 }}
					dataSource={contentData}
					loading={isLoading}
				/>

				{publishMassivePanelVisible && (
					<GooglePublishPanel
						selectedRowKeys={selectedRowKeys}
						visible={publishMassivePanelVisible}
						onFinish={(isScheduled: boolean) => {
							setPublishMassivePanelVisible(false);
							setSelectedRowKeys([]);
							setUpdateData(!updateData);
							isScheduled ? 
								history.push('/contenidos/programados', { from: location })
								:
								setTimeout(() => {
									setLogsDrawer(true);
								}, 500);
						}}
						onCancel={() => {
							setPublishMassivePanelVisible(false);
							setSelectedRowKeys([]);
						}}
					/>)
				}
				
				{publishOnePanelVisible && (
					<GooglePublishPanel
						selectedRowKeys={selectedRowKeys}
						location={publishOnePanelVisible}
						visible={publishOnePanelVisible}
						onFinish={(isScheduled: boolean) => {
							setPublishOnePanelVisible(null);
							setSelectedRowKeys([]);
							setUpdateData(!updateData);
							isScheduled ? 
								history.push('/contenidos/programados', { from: location })
								:
								setTimeout(() => {
									setLogsDrawer(true);
								}, 500);
						}}
						onCancel={() => {
							setPublishOnePanelVisible(null);
							setSelectedRowKeys([]);
						}}
					/>)
				}
				{imagePublishMassivePanelVisible && (
					<ImagePublishPanel
						selectedRowKeys={selectedRowKeys}
						onFinish={() => {
							setImagePublishMassivePanelVisible(false);
							setSelectedRowKeys([]);
							setUpdateData(!updateData);
							setTimeout(() => {
								setLogsDrawer(true);
							}, 500);
						}}
						onCancel={() => {
							setImagePublishMassivePanelVisible(false);
							setSelectedRowKeys([]);
						}}
					/>)
				}
				
				{imagePublishOnePanelVisible && (
					<ImagePublishPanel
						selectedRowKeys={selectedRowKeys}
						location={imagePublishOnePanelVisible}
						onFinish={() => {
							setImagePublishOnePanelVisible(null);
							setSelectedRowKeys([]);
							setUpdateData(!updateData);
							setTimeout(() => {
								setLogsDrawer(true);
							}, 500);
						}}
						onCancel={() => {
							setImagePublishOnePanelVisible(null);
							setSelectedRowKeys([]);
						}}
					/>)
				}				
			</Card>
		</>
	)
}